/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';

export function getBaseUrl() {
  var hostName = window.location.origin;
  //alert(window.location.pathname.split('/')[1])
  var clientName = window.location.pathname.split('/')[1] == '' ? "default" : window.location.pathname.split('/')[1]
  var baseURL = hostName + '/' + clientName;
  
  return baseURL;
}
const clientName = getBaseUrl().replace(location.origin, '').split('/')[1] == '' ? "default" : getBaseUrl().replace(location.origin, '').split('/')[1];

// Get okta settings before bootstrapping
fetch(`./assets/configuration/appconfig.json`)
  .then((response) => response.json())
  .then((config) => {   
    const requestHeaders = {
      headers: {
        'Ocp-Apim-Subscription-Key': `${config.general.apiKey}`,
      },
    };
    fetch(
      `${config.general.adminApiUrl}instanceconfiguration/GetConfigurationByName/${clientName}`, requestHeaders
    )
      .then((response) => response.json())
      .then((instanceConfig) => {
        config.okta.clientId = instanceConfig.oktaClientId;
        config.okta.redirectUri = `${getBaseUrl()}/login/callback`;
        config.okta.postLogoutRedirectUri = `${getBaseUrl()}/login`;
        config.general.gxURL = instanceConfig.gxURL;
        config.general.gxUserName = instanceConfig.gxKey;
        config.general.gxKey = instanceConfig.gxPassword;
        const providersConfig = [
          { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
          { provide: 'CONFIG_SETTINGS', useValue: config },
        ];

        if (environment.production) {
          enableProdMode();
        }

        bootstrapApplication(AppComponent, {
          ...appConfig,
          providers: [providersConfig, ...appConfig.providers],
        }).catch((err) => {
          window.location.reload(); // or redirect to a safe route
        });
      });
  });
